export const PLACARD_LOCATION = [
    { key: 'Front Desk', value: 'upplm.placardlocationdetails.frontdesk' },
    { key: 'Lobby', value: 'upplm.placardlocationdetails.lobby' },
    { key: 'Laboratory', value: 'upplm.placardlocationdetails.laboratory' },
    { key: 'Clinic', value: 'upplm.placardlocationdetails.clinic' },
    { key: 'Metal Box', value: 'upplm.placardlocationdetails.metalbox' },
    { key: 'Hallway', value: 'upplm.placardlocationdetails.hallway' },
    { key: 'Security', value: 'upplm.placardlocationdetails.security' },
    { key: 'Nursing', value: 'upplm.placardlocationdetails.nursing' },
    { key: 'Maternity', value: 'upplm.placardlocationdetails.maternity' },
    { key: 'Nursery', value: 'upplm.placardlocationdetails.nursery' },
    { key: 'Audiology', value: 'upplm.placardlocationdetails.audiology' },
    { key: 'Freezer', value: 'upplm.placardlocationdetails.freezer' },
    { key: 'Counter', value: 'upplm.placardlocationdetails.counter' },
    { key: 'Cabinet', value: 'upplm.placardlocationdetails.cabinet' },
    { key: 'Other', value: 'upplm.placardlocationdetails.other' }
];

export const PICKUP_LOCATION = [
    { key: 'ILB', value: 'upplm.placardlocationdetails.inside' },
    { key: 'OLB', value: 'upplm.placardlocationdetails.outside' }
];

export const PICKUP_LOCATION_KEY = [
    { key: 'inside', value: 'upplm.placardlocationdetails.inside' },
    { key: 'outside', value: 'upplm.placardlocationdetails.outside' }
];

export const PLACARD_LOCATION_DESCRIPTION = {
    INSIDE: 'Inside',
    OUTSIDE: 'Outside'
}

export const CATALOG = {
    PLACARD_LOCATION:'Placard Location',
    PICKUP_LOCATION:'Pickup Location'
}